// Main Components
import * as React from "react"
import { Link } from "gatsby"
import greyFacebookIcon from "../images/grey-fb-logo.png"
import greyTwitterIcon from "../images/grey-twitter-logo.png"
import greyInstagramIcon from "../images/grey-insta-logo.png"
import greyLinkedInIcon from "../images/grey-linkedin-logo.png"
import "./author_block.scss"


const AuthorBlock = ({...props}) => {
  return (
    <div className="author-block-section d-flex">
        {props.authorDetails.photo !== '' ? 
            <img src={props.authorDetails.photo} alt='Author' />
            : null
        }
        <div className="author-name-and-date">
            <Link to={'/author/' + props.authorDetails.userName}><h6>{props.authorDetails.name}</h6></Link>
            <p>{props.authorDetails.date}</p>
        </div>
        <div className="author-sm-links">
            {props.authorDetails.fbLink !== '' ?
                <a rel="noreferrer" target="_blank" href={props.authorDetails.fbLink}>
                    <img 
                        className="img-icon"
                        src={greyFacebookIcon}
                        alt="Facebook Logo" />
                </a>
                : null
            }
            {props.authorDetails.twLink !== '' ? 
            <a rel="noreferrer" target="_blank" href={props.authorDetails.twLink}>
                <img 
                    className="img-icon"
                    src={greyTwitterIcon}
                    alt="Twitter Logo" />
            </a>
                : null
            }
            {props.authorDetails.instaLink !== '' ? 
            <a rel="noreferrer" target="_blank" href={props.authorDetails.instaLink}>
                <img 
                    className="img-icon"
                    src={greyInstagramIcon}
                    alt="Instagram Logo" />
            </a>
                : null
            }
            {props.authorDetails.linkedInLink !== '' ? 
                <a rel="noreferrer" target="_blank" href={props.authorDetails.linkedInLink}>
                    <img 
                        className="img-icon"
                        src={greyLinkedInIcon}
                        alt="LinkedIn Logo" />
                </a>
                : null
            }
        </div>
    </div>
  )
}

export default AuthorBlock
